module.exports = __webpack_public_path__ + "img/fireworks_thumb.78147a7b.jpg";